import React, { PureComponent } from 'react';

const cssModalOpen = 'modal-open';

class ModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
    this.openActiveModal = this.openActiveModal.bind(this);
    this.hideActiveModal = this.hideActiveModal.bind(this);
  }

  componentDidMount() {
    this.openActiveModal();
    setTimeout(() => window.addEventListener('click', this.clickHandler), 500);
  }
  componentWillUnmount() {
    this.hideActiveModal();
    window.removeEventListener('click', this.clickHandler);
  }

  clickHandler({ target }) {

    if (document.getElementsByClassName('modal-content')[0].contains(target)) {
      //Nothing needs to be done
    } else {
      this.hideActiveModal();
    }
  }

  hideActiveModal = () => {
    let { onClose } = this.props;
    const modal = document.getElementsByClassName('modal show')[0];
    const fade = document.getElementsByClassName('modal-backdrop show')[0];
    const modalOpen = document.getElementsByClassName(cssModalOpen)[0];
    if (modal) {
      modal.className = modal.className.replace('show', '');
      modal.style = "display: none;";
    }
    if (fade) {
      fade.className = fade.className.replace('show', '');
      fade.className = fade.className.replace('modal-backdrop', '');
    }
    if (modalOpen) { modalOpen.className = modalOpen.className.replace(cssModalOpen, ''); }
    if (typeof (onClose) === 'function') { onClose(); }
  }

  openActiveModal = () => {
    let { id, onOpen } = this.props;
    const modal = document.getElementById(id ? id : 'ModalComponent');
    const body = document.body;
    const fade = document.createElement("div");
    fade.className = "modal-backdrop show"
    modal.className = modal.className.concat(' show');
    modal.style = "display: block;";
    body.className = body.className.concat(` ${cssModalOpen}`);
    body.appendChild(fade);
    if (typeof (onOpen) === 'function') { onOpen(); }
  }

  render() {
    let { title, body, footer, id, noMinHeight } = this.props;
    let contentClasses = "modal-content";
    if (!noMinHeight) {
      contentClasses += " payment-modal";
    }
    let footerDiv = footer
      ? (<div className="modal-footer">{footer}</div>)
      : (<div />);
    return (<div className="modal" id={id ? id : 'ModalComponent'} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className={contentClasses}>
          <div className="modal-header">
            {typeof (title) === 'string' ? (<h5 className="modal-title">{title}</h5>) : { title }}
          </div>
          <div className="modal-body">
            {body}
          </div>
          {footerDiv}
        </div>
      </div>
    </div>);
  }
}

export default ModalComponent;
